"use client";

import { formatDistanceToNow } from "date-fns";

export default function BugReportList({ bugs, selectedBugId, onSelectBug }) {
  if (bugs.length === 0) {
    return (
      <div className="empty-bug-list">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect width="18" height="18" x="3" y="3" rx="2" />
          <path d="M9 9h.01" />
          <path d="M15 9h.01" />
          <path d="M8 13h8" />
        </svg>
        <h3>No bug reports found</h3>
        <p>There are no bug reports matching your current filter</p>
      </div>
    );
  }

  return (
    <div className="bug-list">
      {bugs.map((bug) => (
        <div
          key={bug.id}
          className={`bug-list-item ${
            selectedBugId === bug.id ? "selected" : ""
          } ${bug.status}`}
          onClick={() => onSelectBug(bug)}
        >
          <div className="bug-list-item-header">
            <div className="bug-type">{bug.bugType}</div>
            <div className={`bug-severity ${bug.severity}`}>
              {bug.severity.charAt(0).toUpperCase() + bug.severity.slice(1)}
            </div>
          </div>

          <div className="bug-details-preview">
            {bug.details.length > 100
              ? bug.details.substring(0, 100) + "..."
              : bug.details}
          </div>

          <div className="bug-list-item-footer">
            <div className="bug-reporter">
              <span className="username">{bug.username}</span>
              <span className="email">{bug.email}</span>
            </div>
            <div className="bug-meta">
              <span className="bug-date">
                {formatDistanceToNow(new Date(bug.date))} ago
              </span>
              {bug.attachments?.length > 0 && (
                <span className="attachment-indicator">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                  </svg>
                  {bug.attachments.length}
                </span>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
